<h1 class="dialog-header" mat-dialog-title>Limitation of Liability and Disclaimer</h1>
<a mat-dialog-content class="close-btn" (click)="onJustClick()">&#10006;&#xFE0E;</a>
<div mat-dialog-content>

  <p class="mat-body">
    Meteomatics Weather Browser is a free online tool hosted by Meteomatics AG in Switzerland to demonstrate data for
    marketing purposes only. As such, commercial use of Meteomatics data without a commercial
    license is prohibited and no guarantees whatsoever are made.
    Meteomatics hereby disclaims any and all liability for loss, injury or damage
    (direct, indirect, consequential, incidental or special)
    arising out of or in connection with use of the Weather Browser and reserves the right to cease providing, or make
    changes to,
    the Weather Browser service at any time without notice.
    You must not attempt to scrape the data supplied through the tool or remove
    any Meteomatics logos or branding from the Weather Browser.
  </p>

</div>
